import { TableRow as MuiTableRow, type TableRowProps as MuiTableRowProps } from "@mui/material";
import type { Theme } from "@mui/material/styles";
import { DotLegalTooltip } from "@dotlegal/dotlegal-ui-components";
import React from "react";

interface TableRowProps extends MuiTableRowProps {
    inactive?: boolean;
    inactiveTooltip?: string;
    tooltip?: string;
}

const inactiveStyle = { opacity: 0.5, backgroundColor: (theme: Theme) => theme.palette.grey[300] };

const TableRow = React.forwardRef<HTMLTableRowElement, TableRowProps>(function TableRow({ inactive, inactiveTooltip, tooltip, ...props }, ref) {
    const row = <MuiTableRow ref={ref} {...props} sx={[inactive ? inactiveStyle : {}, ...(Array.isArray(props.sx) ? props.sx : [props.sx])]} />;
    const rowTooltip = tooltip ?? (inactive ? inactiveTooltip : undefined);

    if (rowTooltip) {
        return <DotLegalTooltip text={rowTooltip}>{row}</DotLegalTooltip>;
    }

    return row;
});

export default TableRow;
